import React from 'react';
import PropTypes from 'prop-types';
import BenefitsImage from '@/images/bike-ampersand.png';
import SectionBenefitsItem from './SectionBenefitsItem';

const SectionBenefits = ({ section, visualAlignment }) => {

  return (
    <div className={`bg-white text-center lg:text-left px-8 py-14 lg:px-24 xl:px-44 2xl:px-60 lg:py-16 w-full ${section.image.url.length > 0 ? '' : 'flex justify-center'}`}>
    <div className={`max-w-7xl mx-auto flex flex-col-reverse ${section.image.url.length > 0 ? 'lg:flex-row lg:gap-10' : ''} items-center`}>
      {section.image.url.length > 0 && visualAlignment=='left' && (
          <div className="lg:pl-6">
            <img
              src={section.image.url.length > 0 ?  section.image.url : BenefitsImage}
              alt="Benefits Visual"
              className="h-[291px] lg:h-[463px]"
            />
          </div>
      )}
      <div className={`flex-1 space-y-4 md:space-y-0 md:flex md:flex-col text-[#1C2938] ${section.image.url.length > 0 ? 'xl:pr-20' : 'mx-auto w-3/5'}`}>
          <h2 className={section.headerClasses}>
            {section.header}
          </h2>
          <div className="
            flex flex-1 flex-col justify-center space-y-6 lg:space-y-0
            divide-y divide-gray-300 max-w-[635px]sm:text-nowrap
          ">
            {section.items.map((item, index) => (
              <div key={index} className="py-4 sm:px-28 lg:px-0">
                <SectionBenefitsItem item={item} />
              </div>
            ))}
          </div>
        </div>
        {section.image.url.length > 0 && visualAlignment=='right' && (
          <div className="lg:pl-6">
            <img
              src={section.image.url}
              alt="Benefits Visual"
              className="h-[291px] lg:h-[463px]"
            />
          </div>
        )}
      </div>
    </div>
  );
};

SectionBenefits.propTypes = {
  section: PropTypes.shape({
      typeOf: PropTypes.string.isRequired,
      header: PropTypes.string,
      headerClasses: PropTypes.string,
      body: PropTypes.string,
      showLogo: PropTypes.bool,
      image: PropTypes.shape({
          url: PropTypes.string.isRequired,
        }),
      customClasses: PropTypes.string,
      items: PropTypes.arrayOf(PropTypes.shape({
        header: PropTypes.string.isRequired,
        headerClasses: PropTypes.string,
        body: PropTypes.string.isRequired
      })).isRequired,
    }).isRequired,
  visualAlignment: PropTypes.string
};

SectionBenefits.defaultProps = {
  visualAlignment: 'right'
}
export default SectionBenefits;
